import React, { useEffect, useState } from 'react';

import ReadOnlySelect from '@features/supplier-onboarding/components/ReadOnlySelect';

import { useSupplierInfo } from '@store/reducers/supplier-onboarding/OnboardingReducer';

import { capitalizeFirstLetter } from '@utils/Util';

import { supplierWorkflowSteps } from '@/constants/constant';

const ProductInformation = ({ setActiveStep }) => {
	const supplier = useSupplierInfo();
	const [productInfo, setProductInfo] = useState({});
	const stepName = 'PRODUCT_INFORMATION';

	useEffect(() => {
		if (supplier) {
			const getTechnicalFacilities = (factoryInfo) => {
				const facilities = [
					{
						condition: factoryInfo.haveEtp,
						value: 'ETP',
						label: 'Etp'
					},
					{
						condition: factoryInfo.haveLab,
						value: 'LAB',
						label: 'Lab'
					},
					{
						condition: factoryInfo.haveRnd,
						value: 'R_AND_D',
						label: 'R&D'
					},
					{
						condition: factoryInfo.haveSample,
						value: 'SAMPLE',
						label: 'Sample'
					},
					{
						condition: factoryInfo.haveStudio,
						value: 'STUDIO',
						label: 'Studio'
					},
					{
						condition: factoryInfo.haveWtp,
						value: 'WTP',
						label: 'Wtp'
					},
					{
						condition: factoryInfo.isComposite,
						value: 'COMPOSITE',
						label: 'Composite'
					}
				];

				return facilities
					.filter((facility) => facility.condition)
					.map((facility) => ({
						value: facility.value,
						label: facility.label
					}));
			};

			const mapWithCapitalizedLabel = (list) =>
				list.map((item) => ({
					label: capitalizeFirstLetter(item),
					value: item
				}));
			const strengthList = supplier.productCategoryStrengthList.map((item) => ({
				label: item.name,
				value: item.constant
			}));
			const supplierData = {
				supplierTypeList: mapWithCapitalizedLabel(supplier.supplierTypeList),
				supplierCategoryList: mapWithCapitalizedLabel(supplier.supplierCategoryList),
				coreProductBaseTypeList: mapWithCapitalizedLabel(supplier.coreProductBaseTypeList),
				productCategoryStrengthList: strengthList,
				productGroupIdList: supplier.departmentList.map((item) => ({
					label: item.name,
					value: item.id
				})),
				technicalFacilities: getTechnicalFacilities(supplier.factoryInfo)
			};
			setProductInfo(supplierData);
		}
	}, [supplier]);

	return (
		<div className="information-form">
			<div className="row">
				<div className="col-md-12">
					<ReadOnlySelect
						label="Supplier Type"
						name="supplierTypeList"
						options={productInfo?.supplierTypeList}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlySelect
						label="Category"
						name="supplierCategoryList"
						options={productInfo?.supplierCategoryList}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlySelect
						label="Department"
						name="productGroupIdList"
						options={productInfo?.productGroupIdList}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlySelect
						label="Core Product Base"
						name="coreProductBaseTypeList"
						options={productInfo?.coreProductBaseTypeList}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlySelect
						label="Product Category Strength"
						name="productCategoryStrengthList"
						options={productInfo?.productCategoryStrengthList}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlySelect
						label="Composite Facilities"
						name="technicalFacilities"
						options={productInfo?.technicalFacilities}
						stepName={stepName}
					/>
				</div>
			</div>
			<div className="submit-button">
				<button
					className="button size32 w-100"
					onClick={() => setActiveStep(supplierWorkflowSteps.DOCUMENT_UPLOAD)}
				>
					Next
				</button>
			</div>
		</div>
	);
};

export default ProductInformation;
